import React, { useCallback } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { useFeedItemDetail } from '../../hooks/useFeedItemDetail';
import FeedItemDetailLayout from './FeedItemDetailsLayout';

// /feed/:schema/:table/:id
//
// Two ids arrive from api2's member pages as well as the feeds' own:
//
//   congressional_bills/BILLS-119hr10473      a bill with no version letters;
//                                             the hook finds its furthest
//                                             published version
//   all_member_votes/314?date=2026-09-16      a House roll call; the date keeps
//                                             it apart from the same number in
//                                             the other session
//
// Links without either behave exactly as before.
const FeedItemDetail = () => {
  const { schema, table, id, sortBy } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const date = searchParams.get('date') || undefined;
  const { item, allVotes, membersData, loading, loadingMembers, error } = useFeedItemDetail(
    schema,
    table,
    id,
    { date }
  );

  const handleBack = useCallback(() => {
    if (sortBy) {
      navigate(`/feed/${schema}/${table}/sort/${sortBy}`);
    } else {
      navigate(`/feed/${schema}/${table}`);
    }
  }, [navigate, schema, table, sortBy]);

  return (
    <FeedItemDetailLayout 
      schema={schema}
      table={table}
      item={item}
      allVotes={allVotes}
      membersData={membersData}
      loading={loading}
      loadingMembers={loadingMembers}
      error={error}
      onBack={handleBack}
    />
  );
};

export default FeedItemDetail;